import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  Icon,
  IconColor,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { MiniTitle } from '@delmonicos/shared-design-system-react/src/components/typography/mini-title/mini-title';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import React from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';

import { useEmspBoEmspUserContext } from '../emsp-bo-emsp-user.context';

export const EmspBoEmspUserConsentListController = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { consents } = useEmspBoEmspUserContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card direction="column" gap={GapEnum.L}>
      <Stack alignItems="center" gap={GapEnum.XS}>
        <AccentTitle
          icon="lock-01"
          text={t('delmonicos-shared-sdk.outputs-emsp-user.consents')}
        />
      </Stack>
      {consents.length === 0 ? (
        <Text color={TextColor.Secondary}>
          {t('$.emsp-bo-emsp-user-consent-list.empty')}
        </Text>
      ) : (
        <Stack direction="column" gap={GapEnum.L}>
          {consents.map((consent, index) => (
            <Stack key={`${index}-${consent.type}`} gap={GapEnum.M}>
              <Stack direction="column" gap={GapEnum.XS}>
                <MiniTitle>
                  {t('delmonicos-shared-sdk.outputs-emsp-user-consent.type')}
                </MiniTitle>
                <Text>{consent.type}</Text>
              </Stack>
              <Stack direction="column" gap={GapEnum.XS}>
                <MiniTitle>
                  {t('delmonicos-shared-sdk.outputs-emsp-user-consent.version')}
                </MiniTitle>
                <Text>{consent.version}</Text>
              </Stack>
              <Stack direction="column" gap={GapEnum.XS}>
                <MiniTitle>
                  {t(
                    'delmonicos-shared-sdk.outputs-emsp-user-consent.language',
                  )}
                </MiniTitle>
                <Text>{consent.language}</Text>
              </Stack>
              {consent.date !== undefined && (
                <Stack direction="column" gap={GapEnum.XS}>
                  <MiniTitle>
                    {t('delmonicos-shared-sdk.outputs-emsp-user-consent.date')}
                  </MiniTitle>
                  <Text>{formatDate(consent.date, i18n)}</Text>
                </Stack>
              )}
              {consent.isConsentGiven !== undefined && (
                <Stack direction="column" gap={GapEnum.XS}>
                  <MiniTitle>
                    {t(
                      'delmonicos-shared-sdk.outputs-emsp-user-consent.is-consent-given',
                    )}
                  </MiniTitle>
                  <Stack alignItems="center" gap={GapEnum.XS}>
                    {consent.isConsentGiven ? (
                      <Icon name="check-circle" color={IconColor.Success} />
                    ) : (
                      <Icon name="x-circle" color={IconColor.Error} />
                    )}
                  </Stack>
                </Stack>
              )}
            </Stack>
          ))}
        </Stack>
      )}
    </Card>
  );
};
